import { Button, SmartLink, Spacer, Stack, XStack, YStack } from '@my/ui'
import { SectionTitle } from 'app/components'
import { OfferCollectionBlock, OfferCollectionDisplayStyle } from './offer-collection.block'
import { FeaturedOfferComponent } from '../featured-offer-block'
import { FeaturedOffersComponent } from '../featured-offers-block/featured-offers.component'

export const OfferCollectionComponent = (block: OfferCollectionBlock) => {
  const displayStyle = block.offerCollectionDisplayStyle as OfferCollectionDisplayStyle
  const bkgColour = block.backgroundColor

  if (block.offers.length === 0) return null

  return (
    <YStack width="100%" flex={1} gap="$3.5">
      {(block.title || block.linkToCollection) && (
        <XStack jc="space-between" columnGap="$3.5" rowGap="$2" ai="center" flexWrap="wrap">
          {block.title && (
            <SectionTitle color={bkgColour === 'black' ? '$white' : '$black'}>
              {block.title}
            </SectionTitle>
          )}
          {!block.title && <Spacer />}
          {block.linkToCollection && (
            <SmartLink
              Component={Button}
              theme="gray"
              href={`/offers/collections/${block.collection.slug}`}
              color={bkgColour === 'black' ? '$white' : '$black'}
              fontWeight="500"
              size="$3"
            >
              View All
            </SmartLink>
          )}
        </XStack>
      )}

      {block.withMainFeaturedCard && block.offers[0] && (
        <Stack mb="$3.5">
          <FeaturedOfferComponent
            id={block.offers[0].id}
            blockName={''}
            blockType="featuredOffer"
            offer={block.offers[0]}
            showEndTime={block.showEndTime}
            withBackgroundImage={false}
            imagePriority={block.imagePriority}
          />
        </Stack>
      )}
      <FeaturedOffersComponent
        id={block.id}
        featuredOfferLimit={block.limit}
        blockName={block.blockName}
        blockType="featuredOffers"
        displayStyle={displayStyle}
        offers={block.withMainFeaturedCard ? block.offers.slice(1) : block.offers}
        cardType={block.collectionCardType}
        showEndTime={block.showEndTime}
        imagePriority={block.imagePriority}
      />
    </YStack>
  )
}
